import { render, staticRenderFns } from "./SearchAddressModal.vue?vue&type=template&id=10513810&"
import script from "./SearchAddressModal.vue?vue&type=script&lang=js&"
export * from "./SearchAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports